import { Injectable } from "@angular/core"

@Injectable({
    providedIn: 'root',
})
export class DateUtilsService {
    getTimeAgo(date: Date) {
        let today = new Date();
        if(typeof date == "string"){
          //esto es lo que me esta devolviendo la funcion getall en vez de la de all... no se porqué
          date = new Date(date);
        }
        let diff = today.getTime() - date.getTime();
        
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));
        let diffHours = diff - days * (1000 * 60 * 60 * 24);
        let hours = Math.floor(diffHours / (1000 * 60 * 60));
        let diffMinutes = diff - days * (1000 * 60 * 60 * 24) - hours * (1000 * 60 * 60);
        let minutes = Math.floor(diffMinutes / (1000 * 60));
        let message = "";
        if(days>0) message = days + " días";
        if(hours>0) message += (message!=""?" y ":"") + hours + " horas";
        if(days==0 && minutes>0) message += (message!=""?" y ":"") + minutes + " minutos";
        if(message == "") message = "< 1 minuto";
        return message;
      }
}